"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Constants = {
    formatSeparator: "_",
    twoDigitYearMax: 68,
    defaultDateFormat: "d",
    defaultLocaleId: "en"
};
